var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-row', {
    staticClass: "ma-n1"
  }, [_c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "6",
      "md": "auto"
    }
  }, [_c('v-text-field', _vm._b({
    attrs: {
      "label": "기간검색(시작일)",
      "value": _vm.duration[0],
      "type": "date",
      "max": "2999-12-31"
    },
    on: {
      "input": function input(value) {
        return _vm.setAt(0, value);
      }
    }
  }, 'v-text-field', _vm.attrs_input, false))], 1), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "6",
      "md": "auto"
    }
  }, [_c('v-text-field', _vm._b({
    attrs: {
      "label": "기간검색(종료일)",
      "value": _vm.duration[1],
      "type": "date",
      "max": "2999-12-31"
    },
    on: {
      "input": function input(value) {
        return _vm.setAt(1, value);
      }
    }
  }, 'v-text-field', _vm.attrs_input, false))], 1), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "12",
      "md": "auto"
    }
  }, [_c('search-duration-type', {
    attrs: {
      "value": _vm.duration
    },
    on: {
      "input": _vm.onType
    }
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }